var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    clipPath: "url(#clip0_3000_23973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 7.16634C8.27484 7.16634 8.4987 7.3902 8.4987 7.66634V10.9997C8.4987 11.2758 8.27484 11.4997 7.9987 11.4997C7.72256 11.4997 7.4987 11.2758 7.4987 10.9997V7.66634C7.4987 7.3902 7.72256 7.16634 7.9987 7.16634Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33985 4.62729C8.5451 4.81202 8.56174 5.12816 8.37701 5.33342L8.37035 5.34082C8.18562 5.54608 7.86947 5.56272 7.66422 5.37799C7.45896 5.19326 7.44232 4.87711 7.62705 4.67186L7.63372 4.66445C7.81845 4.4592 8.13459 4.44256 8.33985 4.62729Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 1.83301C4.59294 1.83301 1.83203 4.59392 1.83203 7.99967C1.83203 11.4054 4.59294 14.1663 7.9987 14.1663C11.4045 14.1663 14.1654 11.4054 14.1654 7.99967C14.1654 4.59392 11.4045 1.83301 7.9987 1.83301ZM0.832031 7.99967C0.832031 4.04163 4.04066 0.833008 7.9987 0.833008C11.9567 0.833008 15.1654 4.04163 15.1654 7.99967C15.1654 11.9577 11.9567 15.1663 7.9987 15.1663C4.04066 15.1663 0.832031 11.9577 0.832031 7.99967Z",
    fill: "#656579"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3000_23973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.d53c70941cf029edd7259328ccaf1e65.svg";
export { ForwardRef as ReactComponent };